

import { useMemo } from "react";
import { IBigscreenSettings } from "../constants/interfaces";
import { useSelector } from "react-redux";

type BigscreenSettings = {
    data: IBigscreenSettings[];
    isLoading: boolean;
};

const useCurrentBrandsBigscreenSettings = (brands: Array<string>): Array<IBigscreenSettings>  => {
    const bigscreenSettings = useSelector((state: { bigscreenSettings: BigscreenSettings }) => state.bigscreenSettings.data);

    const currentBigScreenSettings = useMemo(() => {
        if (!Array.isArray(brands) || brands.length === 0) {
            const hostname = window.location.hostname;
            const splitIndex = hostname.search(/(\.|-)/);
            return bigscreenSettings.filter(settings => hostname.substring(0, splitIndex) === settings.id);
        }

        return bigscreenSettings.filter(settings => brands.includes(settings.id));
    }, [brands, bigscreenSettings])

    return currentBigScreenSettings
};

export default useCurrentBrandsBigscreenSettings;
